import { Aluno } from 'models/aluno';

export class Contratante {
  idContrante: number;
  nome: string;
  cpfCnpj: string;
  cpf: string;
  email: string;
  telefone: string;
  endereco: string;
  cidade: string;
  uf: string;
  rg: string;
  cep: string;
  alunosVinculados: Aluno[];

  constructor(args = {}) {
    Object.assign(this, args);
    if (this.alunosVinculados) {
      this.alunosVinculados = this.alunosVinculados.map(aluno => new Aluno(aluno));
    }
  }
}
